import { render } from "./CompanyDetailsPageSvg.vue?vue&type=template&id=4ed9aa8f"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__